import React, { Fragment } from 'react'
import './WishlistCard.css';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

function WishlistCard({wishlst, onRemoveWishlistItem}) {

  return (
    <Fragment>
        <div className='wl_card'>
            <span className='wl_rmv_btn' onClick={()=> onRemoveWishlistItem(wishlst._id)}><CloseRoundedIcon fontSize='extraSmall'/></span>
            <div className='wl_card_img'>
                <img src='../img/m_ban_3.jpg' alt='wishlist image'/>
            </div>
            <div className='wl_card_inr'>
                <span>{wishlst.product.name}</span>
                <div className='wl_prc_bx'><span>Rs.600</span><span>Rs.899</span></div>
            </div>
            <div className='wl_m2c_btn'>MOVE TO CART</div>
        </div>
        <div>
          
        </div>
    </Fragment>
  )
}

export default WishlistCard